import React from 'react';
import ReactDOM from 'react-dom';
// import {
//     QueryClient,
//     QueryClientProvider,
// } from 'react-query'
// import { persistQueryClient } from 'react-query/persistQueryClient-experimental'
// import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental'

import {
    has,
    head,
    complement,
    equals,
    prop,
    pipe,
    reduce,
    filter,
    map,
    objOf,
    mergeRight,
    useWith,
    call,
    apply,
    pick
} from 'ramda'

import { PostCollection, FilteredPostCollection } from './components/index.js'

import { SWRConfig } from 'swr';
// import FilteredPostCollection from './components/FilteredPostCollection.js';

// const cacheTime = 1000 * 60 * 60 * 24 // 24 hours
// // const element = document.getElementById('post-collection')
// const queryClient = new QueryClient({
//     defaultOptions: {
//         queries: {
//             cacheTime
//         },
//     },
// })

// const localStoragePersistor = createWebStoragePersistor({ storage: window.localStorage })


// persistQueryClient({
//     queryClient,
//     persistor: localStoragePersistor,
//     maxAge: cacheTime,
// })


const elements = [...document.querySelectorAll('.post-collection')]
elements.forEach(element => {
    if (element && element.dataset) {
        const {
            query,
            filterMenuEnabled,
            searchEnabled,
            searchLabel,
            selectedTaxonomies,
            columns = 3,
            rows = 3,
            sortByEnabled,
            sortByDefault,
            sortDirectionDefault,
            selectedSortOptions,
            loadMoreEnabled,
            showTitleImage
        } = JSON.parse(element.dataset.blockAttributes)
        // const categories = [381]
        ReactDOM.render(
            <React.StrictMode>
                <SWRConfig value={{ provider: localStorageProvider }}>
                    <FilteredPostCollection
                        query={{
                            ...query,
                            types: query.types.filter(has('slug')),
                            ...pipe(
                                Object.entries,
                                filter(
                                    pipe(
                                        head,
                                        complement(equals)('types')
                                    )
                                ),
                                map(apply(useWith(call, [objOf, map(prop('id'))]))),
                                reduce(mergeRight, {}),
                            )(query),
                            ...pick(['order', 'orderBy'], query)
                        }}
                        columns={columns}
                        rows={rows}
                        searchControlEnabled={searchEnabled}
                        searchControlPlaceholder='Enter keywords'
                        searchControlLabel={searchLabel}
                        selectedSortOptions={selectedSortOptions}
                        sortByEnabled={sortByEnabled}
                        filterControlsEnabled={filterMenuEnabled}
                        taxonomyFilters={Object.entries(selectedTaxonomies || {}).reduce((acc, [key, value]) => {
                            return value ? [...acc, key] : acc
                        }, []) || []}
                        postTypeFilterControlEnabled={false}
                        loadMoreEnabled={loadMoreEnabled}
                        showTitleImage={showTitleImage}
                    />
                </SWRConfig>
            </React.StrictMode>,
            element
        );
    }
})


function localStorageProvider() {
    // When initializing, we restore the data from `localStorage` into a map.
    const map = new Map(JSON.parse(localStorage.getItem('app-cache') || '[]'))

    // Before unloading the app, we write back all the data into `localStorage`.
    window.addEventListener('beforeunload', () => {
        const appCache = JSON.stringify(Array.from(map.entries()))
        localStorage.setItem('app-cache', appCache)
    })

    // We still use the map for write & read for performance.
    return map
}